<template>
  <div class="gf-list">
    <ul class="gf-file-list" :class="{icons: display=='icon', 'file-list': display=='list'}">
      <li v-if="parent">
        <a href="" @click.prevent="openDir(parentParent)">
          <i style="font-size: 1.5em" class="fa-solid fa-square-caret-up"></i>&nbsp;
          Up
        </a>
      </li>
      <li v-for="file in files">
        <ListCheckBox :list="innerSelected" :value="file.uuid" />
        <template v-if="file.type=='Folder'">
          <a href="" @click.prevent="openDir(file)">
            <FileIcon folder />
            <div class="details">
              {{ file.description }}
            </div>
          </a>
        </template>
        <template v-else-if="file.type=='Link'">

            <FileIcon item />
            <a href="" class="details" :class="{completed: file.completed}" @click.prevent="editDescription(file)">
              {{ file.description }}
            </a>

            <div class="actions">
              <button v-if="!file.completed" class="btn btn-secondary" @click.prevent="markCompleted(file)">
                Završeno
              </button>
              <button v-else="!file.completed" class="btn" @click.prevent="markCompleted(file)">
                Vrati
              </button>
            </div>
        </template>
      </li>
    </ul>
  </div>
  <Popup v-model="descriptionEdit">
    <template v-slot:header>
      <h2>Planirana aktivnost</h2>
    </template>

    <div class="gen-form-container">
      <div class="gen-form-box-popup">
        <div class="gf-row">
          <div class="col-md-12">
            <label>Opis</label>
            <FormInput v-model="descriptionEdit.description" />
          </div>
        </div>
      </div>
    </div>

    <template v-slot:actions>
      <button class="btn" @click.prevent="descriptionEdit=null">Odustanite</button>
      &nbsp;
      <button class="btn" @click.prevent="saveDescription">Sačuvajte</button>
    </template>
  </Popup>
</template>

<script>
import api from "@/Util/api";
import { DateTime } from "luxon";
export default {
  props: ["parent", "selected", "sort", "display", "hasUse"],
  data: ()=>({
    files: [],
    descriptionEdit: null,
  }),
  watch: {
    parent: {
      handler() {
        this.files=[];
        this.loadFiles();
      }, immediate: true,
    },
  },
  computed: {
    currentClient() {
      return this.stores.auth.currentClient;
    },
    parentParent() {
      return this.parent?.parent || null;
    },
    innerSelected: {
      get() {
        return this.selected;
      },
      set(newValue) {
        this.$emit("update:selected", newValue);
      },
    },
  },
  methods: {
    async editDescription(file) {
      this.descriptionEdit=await api.get("ToDo", file.uuid);
    },
    async saveDescription() {
      if (this.descriptionEdit) {
        this.descriptionEdit.save();
        this.descriptionEdit=null;
        await this.loadFiles();
      }
    },
    formatFileSize(bytes) {
      bytes=bytes || 0;
      var suffixes=["B", "kiB", "MiB", "GiB", "TiB"];
      var index=0;
      while(bytes>=1024 && index<suffixes.length-1) {
        bytes/=1024;
        index++;
      }
      return bytes.toFixed(0)+" "+suffixes[index];
    },
    formatDate(date) {
      return DateTime.fromSQL(date).setLocale("sr-Latn-RS").toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
    },
    basename(filepath) {
      return String(filepath).replace(/^.*\//, "");
    },
    async markCompleted(file) {
      file.completed=!file.completed;
      file.save("{completed}");
      this.$emit("reload");
    },
    async loadFiles() {
      if (this.parent)
        this.files=await api.list("ToDo", [["parent", "=", this.parent?.uuid]]);
      else
        this.files=await api.list("ToDo", [["parent", "IS NULL"]]);
    },
    openDir(file) {
      this.$emit("openDir", file);
    },
    callCallback(file) {
      if (this.stores.callbacks.lastCallback) {
        this.stores.callbacks.lastCallback(file);
        this.$router.go(-1);
      }
    },
  },
}
</script>
